export enum CALL_STATUS {
  DIALING = 'DIALING',
  ANSWERED = 'ANSWERED',
  CANCELLED = 'CANCELLED',
  REFUSED = 'REFUSED',
  ENDED = 'ENDED',
  TIMEOUT = 'TIMEOUT',
  BUSY = 'BUSY',
}
